module.exports = __webpack_public_path__ + "img/0-11.3082df43.jpg";